export function customTitle(title: string) {
    // Cambiar palabras rodeadas por '**' para negrita
    title = title.replace(
        /\*\*([^*]+)\*\*/g,
        '<strong>$1</strong>',
    );

    // Cambiar palabras rodeadas por '*' para magenta (y asegurarnos de no interferir con negrita)
    title = title.replace(
        /\*([^*]+)\*/g,
        '<span style="color:#ee2b7b;">$1</span>',
    );

    // Cambiar palabras rodeadas por '[]' con formato de fuente personalizada
    title = title.replace(/\[([^\]]+)\]/g, '<span style="text-transform:lowercase;font-family:Baskerville SemiBold italic version;">$1</span>');

    // Reemplazar '/n' por salto de línea
    title = title.replace(/\/n/g, '<br/>');

    // Convertir texto rodeado por '_' a itálico
    title = title.replace(/_([^_]+)_/g, '<em>$1</em>');

    return title;
}
